// eslint-disable-next-line import/no-anonymous-default-export
export default {
  Coder: "Coder",
  Auditor: "Auditor",
  Manager: "Manager",
  TeamLead: "Team Lead",
};
